import React from 'react'
import Joyride, { ACTIONS, EVENTS } from 'react-joyride'
import { useMount, useSetState } from 'react-use'

export default function JoyrideTour(props) {
  const { run, joyRideSteps, joyRideProps, handleSetAction } = props
  const [{ stepIndex, steps }, setState] = useSetState({
    stepIndex: 0,
    steps: []
  })

  useMount(() => {
    let combinedResult = []

    joyRideSteps.map(item => combinedResult.push({ ...item, ...joyRideProps }))

    setState({
      steps: combinedResult
    })
  })

  const handleJoyrideCallback = data => {
    const { action, index, type } = data

    handleSetAction(action)

    if ([EVENTS.STEP_AFTER, EVENTS.TARGET_NOT_FOUND].includes(type)) {
      const nextStepIndex = index + (action === ACTIONS.PREV ? -1 : 1)

      // Update state to advance the tour
      setState({
        stepIndex: nextStepIndex
      })
    }
  }

  return (
    <Joyride
      callback={handleJoyrideCallback}
      styles={{
        options: {
          primaryColor: '#2e933c'
        },
        tooltipContainer: {
          textAlign: 'left'
        },
        tooltipFooter: {
          marginTop: 0
        },
        tooltipContent: {
          padding: '15px 5px'
        }
      }}
      continuous
      run={run}
      scrollToFirstStep
      showProgress
      showSkipButton
      stepIndex={stepIndex}
      steps={steps}
    />
  )
}
